import DOMPurify from "dompurify";

export function sanitizeNarrativeHtml(html) {
  const root = document.createElement("div");
  root.innerHTML = DOMPurify.sanitize(String(html || ""), {
    ALLOWED_TAGS: ["p", "div", "br", "span", "font", "b", "strong", "i", "em", "u", "s", "ul", "ol", "li", "blockquote", "h1", "h2", "h3", "h4", "a"],
    ALLOWED_ATTR: ["href", "title", "style", "color", "align"],
    ALLOW_DATA_ATTR: false,
    ALLOW_ARIA_ATTR: false,
  });
  // Word/Google Docs often encode bold and italics as inline styles.
  // Preserve those semantics, then discard pasted layout and arbitrary CSS.
  root.querySelectorAll("font").forEach(node => {
    const span = document.createElement("span");
    span.setAttribute("style", node.getAttribute("style") || "");
    if (node.getAttribute("color")) span.style.color = node.getAttribute("color");
    while (node.firstChild) span.appendChild(node.firstChild);
    node.replaceWith(span);
  });
  root.querySelectorAll("[style], [align], [color]").forEach(node => {
    const { fontWeight, fontStyle, textDecoration, textDecorationLine } = node.style;
    const color = node.style.color;
    const alignment = node.style.textAlign || node.getAttribute("align");
    const tags = [];
    if (fontWeight === "bold" || Number.parseInt(fontWeight, 10) >= 600) tags.push("strong");
    if (fontStyle === "italic") tags.push("em");
    if (`${textDecoration} ${textDecorationLine}`.includes("underline")) tags.push("u");
    node.removeAttribute("style");
    node.removeAttribute("align");
    node.removeAttribute("color");
    if (color && /^(#[\da-f]{3,8}|rgba?\([\d\s.,%]+\)|[a-z]+)$/i.test(color)) node.style.color = color;
    if (["left", "center", "right", "justify"].includes(alignment)) node.style.textAlign = alignment;
    for (const tag of tags) {
      const wrapper = document.createElement(tag);
      while (node.firstChild) wrapper.appendChild(node.firstChild);
      node.appendChild(wrapper);
    }
  });
  return root.innerHTML;
}

export function narrativeEditorHtml(value) {
  const text = String(value || "");
  if (/<\/?[a-z][^>]*>/i.test(text)) return sanitizeNarrativeHtml(text);
  return plainTextHtml(text);
}

export function plainTextHtml(text) {
  const node = document.createElement("div");
  node.textContent = String(text || "");
  return node.innerHTML.replace(/\r\n?|\n/g, "<br>");
}

export function narrativePlainText(value) {
  const node = document.createElement("div");
  node.innerHTML = narrativeEditorHtml(value).replace(/<(?:br\s*\/?|\/p|\/div|\/li|\/h[1-4])>/gi, "$& ");
  return (node.textContent || "").replace(/\s+/g, " ").trim();
}
